import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { StaticToastTypes } from './static-toast.types';

@Component({
  selector: 'ui-static-toast',
  templateUrl: './static-toast.component.html',
  styleUrls: ['./static-toast.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class StaticToastComponent {
  @Output() closeToast: EventEmitter<any> = new EventEmitter();
  @Input() type: StaticToastTypes = StaticToastTypes.SUCCESS;
  @Input() icon: string | null = 'icons-positive';

  onClose(): void {
    this.closeToast.emit();
  }
}
